/**
 * Enum for BillQuoteType
 */
export enum BillQuoteType {
  BILL = 1,
  QUOTE = 2,
}
